export default "__VITE_ASSET__6mnBqSY4__"